import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_customer_group",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "modal-footer flex-center" }
const _hoisted_9 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_10 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.customerGroupData,
          ref: "addCustomerGroupForm"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t("message.ADD")} ${_ctx.$t("message.CUSTOMER_GROUP")}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Input, {
                  type: "text",
                  name: "name",
                  label: _ctx.$t('message.NAME'),
                  placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                  requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                  "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.customerGroupData.name = $event)),
                  target: "name",
                  required: true,
                  value: _ctx.customerGroupData.name
                }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t("message.CANCEL")), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("message.SUBMIT")), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}